const fr = {
  // Navbar
  nav_home: "Accueil",
  nav_about: "\u00c0 propos de Tenten-Ojisan",
  nav_services: "Services & Tarifs",
  nav_flow: "Comment \u00e7a marche",
  nav_testimonials: "T\u00e9moignages",
  nav_faq: "FAQ",
  nav_contact: "Contact",
  nav_cta: "R\u00e9server une lecture",
  nav_subtitle: "Lecture de noms \u00b7 Okinawa",
  nav_title: "Divination Tenten-Ojisan",

  // Hero
  hero_headline1: "Sur une \u00eele paisible",
  hero_headline2: "d\u2019Okinawa,",
  hero_headline3: "il \u00e9coute la voix",
  hero_headline4: "de votre nom.",
  hero_body: "Une lecture de noms tr\u00e8s appr\u00e9ci\u00e9e, avec des mois d\u2019attente.\nChaque mois, je me rends sur l\u2019\u00eele \u00e0 votre place\net confie personnellement votre nom au ma\u00eetre.",
  hero_pill1: "Aucun changement de nom",
  hero_pill2: "100% en ligne",
  hero_pill3: "Livr\u00e9 en moins d\u20191 mois",
  hero_pill4: "100 premiers par mois",
  hero_btn_apply: "R\u00e9server une lecture",
  hero_btn_services: "Voir les services",
  hero_scroll: "D\u00c9FILER",

  // About
  about_heading: "\u00c0 propos de Tenten-Ojisan",
  about_intro: "Sur l\u2019\u00eele tranquille d\u2019\u003cstrong\u003eIkei-jima\u003c/strong\u003e, envelopp\u00e9e par la douce mer d\u2019Okinawa,\nil y a un homme qui ajoute silencieusement de la lumi\u00e8re au nom de chaque personne.\nLes gens l\u2019appellent affectueusement \u003cstrong\u003e\u00ab\u00a0Tenten-Ojisan\u00a0\u00bb\u003c/strong\u003e.",
  about_block1_label: "De banquier \u00e0 lecteur de noms",
  about_block1_text: "Tenten-Ojisan \u00e9tait \u00e0 l\u2019origine banquier.\nGr\u00e2ce \u00e0 son d\u00e9vouement, il est devenu le \u003cstrong\u003eplus jeune directeur d\u2019agence\u003c/strong\u003e de son entreprise.\nEn travaillant avec de nombreuses personnes, une question est n\u00e9e dans son c\u0153ur.",
  about_block1_quote: "\u00ab\u00a0Pourquoi certaines personnes semblent-elles avoir le vent en poupe, m\u00eame quand tout le monde travaille aussi dur\u00a0?\u00a0\u00bb",
  about_block1_sub: "Cette petite question est devenue le d\u00e9but d\u2019un grand voyage de d\u00e9couverte.",
  about_block2_label: "Sagesse ancienne et r\u00e9v\u00e9lation silencieuse",
  about_block2_text: "Il a consacr\u00e9 chaque moment libre \u00e0 l\u2019\u00e9tude d\u2019anciens textes de lecture de noms, recherchant soigneusement le nombre de traits des caract\u00e8res traditionnels et le flux des sons.",
  about_block2_text2: "Il a r\u00e9alis\u00e9 que \u003cstrong\u003e\u00ab\u00a0les ten-ten (marques sonores) peuvent harmoniser silencieusement le flux d\u2019un nom.\u00a0\u00bb\u003c/strong\u003e",
  about_block2_sub: "Ce n\u2019\u00e9tait pas de la magie dramatique ni une formule de succ\u00e8s tape-\u00e0-l\u2019\u0153il,\nmais une fa\u00e7on douce de rendre plus visible la lumi\u00e8re d\u00e9j\u00e0 pr\u00e9sente en une personne.",
  about_block3_label: "Bouche-\u00e0-oreille, maintenant 6 mois d\u2019attente",
  about_block3_text: "Ses lectures douces se sont r\u00e9pandues uniquement par le bouche-\u00e0-oreille, et maintenant \u003cstrong\u003edes demandes arrivent de tout le Japon\u003c/strong\u003e.\nQu\u2019ils soient c\u00e9l\u00e8bres ou non, il traite chaque personne avec le m\u00eame soin.\nIl pose sa main sur chaque nom et marche aux c\u00f4t\u00e9s de la vie de cette personne.\nC\u2019est le style de Tenten-Ojisan.",

  // Gallery
  gallery_heading: "Galerie",
  gallery_sub: "Okinawa \u00b7 \u00cele d\u2019Ikei",

  // Services
  services_heading: "Services & Tarifs",
  services_note1: "\u203b Tous les frais incluent les honoraires du ma\u00eetre et notre service de repr\u00e9sentation sur place.",
  services_note2: "\u203b Aucun frais suppl\u00e9mentaire. N\u2019h\u00e9sitez pas \u00e0 nous faire confiance.",
  services_tab1: "Nom personnel",
  services_tab2: "Nom commercial",
  services_tab3: "Nom d\u2019animal",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "En observant doucement la croissance, l\u2019environnement et les mouvements du c\u0153ur, nous ajoutons le ten-ten parfait pour vous.",
  services_tab2_desc: "Un vent favorable pour les nouveaux d\u00e9fis. Harmonisant doucement le flux de votre activit\u00e9.",
  services_tab3_desc: "Pour le membre de la famille toujours \u00e0 vos c\u00f4t\u00e9s. Nous livrons un nom rempli de paix et de chaleur.",
  services_row1_target1: "16 ans et plus",
  services_row1_target2: "4\u201315 ans",
  services_row1_target3: "0\u20133 ans",
  services_row2_target1: "Boutique / Entreprise / Nom commercial",
  services_row3_target1: "Nom d\u2019animal de compagnie",
  services_col_target: "Destinataire",
  services_col_price: "Prix (TVA incl.)",
  services_cta: "Demander ce service",
  services_includes_title: "Ce qui est inclus (tout dans le tarif)",
  services_inc1: "Lecture du nom",
  services_inc2: "Suggestion optimale de ten-ten",
  services_inc3: "Carte format carte de visite envoy\u00e9e sur demande (gratuit)",
  services_inc4: "Conseils pour la bonne fortune",
  services_inc5: "Photo num\u00e9rique de la carte de nom",
  services_includes_note: "Une lecture pour faire ressortir doucement le charme d\u00e9j\u00e0 pr\u00e9sent dans votre nom.",
  services_payment_title: "Paiement",
  services_payment_method: "Virement bancaire (pr\u00e9paiement)",
  services_payment_desc: "Nous fournirons les coordonn\u00e9es bancaires apr\u00e8s votre demande.\nD\u00e8s que votre paiement est effectu\u00e9, le flux de la fortune commence silencieusement \u00e0 s\u2019aligner.",
  services_first_title: "Pour les nouveaux visiteurs",
  services_first_desc: "Il est naturel de se sentir incertain.\nCe sentiment est un signal de votre c\u0153ur\nqu\u2019il est temps de commencer un changement doux.",
  services_first_cta: "Commencer par une consultation",

  // Flow
  flow_heading: "Comment \u00e7a marche",
  flow_step1_title: "Soumettre le formulaire de demande",
  flow_step1_c1: "Veuillez remplir les informations requises dans le formulaire d\u00e9di\u00e9.",
  flow_step1_c2: "Apr\u00e8s l\u2019envoi, vous recevrez un e-mail de r\u00e9ponse dans les 2 \u00e0 3 jours ouvrables.",
  flow_step1_c3: "L\u2019e-mail inclura les prochaines \u00e9tapes et les instructions de virement bancaire.",
  flow_step2_title: "Transf\u00e9rer les frais de lecture",
  flow_step2_c1: "Veuillez transf\u00e9rer les frais de lecture au compte indiqu\u00e9 dans l\u2019e-mail de r\u00e9ponse.",
  flow_step2_c2: "Une fois confirm\u00e9, nous commencerons \u00e0 pr\u00e9parer votre lecture dans l\u2019ordre.",
  flow_step3_title: "Nous informer de votre virement",
  flow_step3_c1: "Apr\u00e8s le virement, veuillez envoyer une photo de votre re\u00e7u \u00e0 l\u2019adresse indiqu\u00e9e dans l\u2019e-mail.",
  flow_step3_c2: "Une fois confirm\u00e9, nous vous enverrons un message \u00ab\u00a0Inscription termin\u00e9e\u00a0\u00bb.",
  flow_step3_note: "Sans cette notification, nous pourrions ne pas \u00eatre en mesure de commencer votre lecture. Assurez-vous de l\u2019envoyer.",
  flow_step4_title: "Recevoir les r\u00e9sultats de votre lecture",
  flow_step4_c1: "Dans environ une semaine apr\u00e8s la lecture, nous vous enverrons par e-mail une photo de votre carte de nom avec ten-ten.",
  flow_step4_c2: "Nous enverrons ensuite un rapport de lecture d\u00e9taill\u00e9 et des conseils de bonne fortune par e-mail.",
  flow_step5_title: "Envoi de la carte de nom (optionnel)",
  flow_step5_c1: "Sur demande, nous enverrons une carte format carte de visite \u00e9crite \u00e0 la main par le ma\u00eetre.",
  flow_step5_c2: "Veuillez entrer votre adresse postale exacte dans le champ adresse du formulaire de demande.",
  flow_step5_note: "Si vous n\u2019avez pas besoin de la carte, indiquer seulement votre ville suffit.",
  flow_banner_title: "Enti\u00e8rement en ligne. De partout au Japon.",
  flow_banner_desc: "Pas besoin de se rendre sur l\u2019\u00eele d\u2019Ikei \u00e0 Okinawa.\nVous pouvez commencer tel que vous \u00eates, sans changer votre vie quotidienne.",
  flow_banner_cta: "Demander maintenant",

  // Testimonials
  testimonials_heading: "T\u00e9moignages",
  testimonials_viewing: "En cours de lecture",

  // FAQ
  faq_heading: "Questions fr\u00e9quentes",
  faq_cta_title: "Vous avez encore des questions\u00a0?",
  faq_cta_desc: "M\u00eame les petites choses sont les bienvenues.\nLes questions que vous h\u00e9sitez \u00e0 poser sont exactement celles que nous voulons entendre.",
  faq_cta_btn: "N\u2019h\u00e9sitez pas \u00e0 demander",

  // CTA Banner
  cta_heading1: "Consultation",
  cta_heading2: "gratuite",
  cta_btn: "R\u00e9server maintenant",

  // Contact
  contact_heading: "Contactez-nous",
  contact_desc: "N\u2019h\u00e9sitez pas \u00e0 nous contacter via ce formulaire pour des demandes de lecture ou des questions. Nous r\u00e9pondons g\u00e9n\u00e9ralement dans les 2 \u00e0 3 jours ouvrables.",
  contact_address_label: "Adresse",
  contact_address_value: "Tochigi, Japon (En ligne \u00b7 Tout le pays)",
  contact_email_label: "E-mail",
  contact_hours_label: "Horaires",
  contact_hours_value: "Jours ouvrables 9h00\u201318h00 (Ferm\u00e9 Sam/Dim/Jours f\u00e9ri\u00e9s)",
  contact_note_title: "\u00c0 propos des r\u00e9ponses",
  contact_note_desc: "Notre r\u00e9ponse peut se retrouver dans votre dossier spam.\nSi vous n\u2019avez pas re\u00e7u de r\u00e9ponse apr\u00e8s 2 \u00e0 3 jours ouvrables, contactez-nous directement par e-mail.",
  contact_field_name: "Nom complet",
  contact_field_furigana: "Furigana (lecture)",
  contact_field_email: "Adresse e-mail",
  contact_field_phone: "Num\u00e9ro de t\u00e9l\u00e9phone",
  contact_field_service: "Service souhait\u00e9",
  contact_field_message: "Message",
  contact_placeholder_name: "Jean Dupont",
  contact_placeholder_furigana: "\u30e4\u30de\u30c0 \u30bf\u30ed\u30a6",
  contact_placeholder_email: "exemple@email.com",
  contact_placeholder_phone: "+33 0 00 00 00 00",
  contact_placeholder_message: "Veuillez entrer le nom que vous souhaitez faire lire, ou toute question ou demande.",
  contact_select_placeholder: "S\u00e9lectionner",
  contact_service1: "Nom personnel",
  contact_service2: "Nom commercial",
  contact_service3: "Nom d\u2019animal",
  contact_service4: "Autre / Consultation",
  contact_submit: "Envoyer",
  contact_submitting: "Envoi en cours...",
  contact_privacy: "Les informations personnelles soumises seront utilis\u00e9es uniquement pour les services de lecture.",
  contact_error: "L\u2019envoi a \u00e9chou\u00e9. Veuillez r\u00e9essayer plus tard ou nous contacter directement par e-mail.",
  contact_err_name: "Veuillez entrer votre nom",
  contact_err_email_required: "Veuillez entrer votre adresse e-mail",
  contact_err_email_invalid: "Veuillez entrer une adresse e-mail valide",
  contact_err_service: "Veuillez s\u00e9lectionner un service",
  contact_err_message_required: "Veuillez entrer votre message",
  contact_err_message_limit: "Veuillez limiter votre message \u00e0 500 caract\u00e8res",
  contact_thanks_title: "Message envoy\u00e9",
  contact_thanks_desc: "Merci de nous avoir contact\u00e9s.\nNous examinerons votre message et r\u00e9pondrons dans les \u003cstrong\u003e2 \u00e0 3 jours ouvrables\u003c/strong\u003e.\nVeuillez patienter un moment.",
  contact_thanks_check1: "Veuillez v\u00e9rifier votre e-mail de confirmation",
  contact_thanks_check2: "V\u00e9rifiez \u00e9galement votre dossier spam",
  contact_thanks_check3: "Veuillez pr\u00e9voir 2 \u00e0 3 jours ouvrables pour une r\u00e9ponse",
  contact_thanks_another: "Envoyer un autre message",

  // Footer
  footer_subtitle: "Lecture de noms \u00b7 Okinawa",
  footer_title: "Divination Tenten-Ojisan",
  footer_desc: "D\u2019Okinawa \u00e0 tout le Japon. Un ma\u00eetre de la lecture de noms avec plus de 50 ans d\u2019exp\u00e9rience lit attentivement le destin dans votre nom.",
  footer_contact_title: "INFORMATIONS DE CONTACT",
  footer_address_label: "ADRESSE",
  footer_address_value: "Tochigi, Japon\n(En ligne \u00b7 Tout le pays)",
  footer_email_label: "E-MAIL",
  footer_hours_label: "HORAIRES",
  footer_hours_value: "Jours ouvrables 9h00\u201318h00\n(Ferm\u00e9 Sam/Dim/Jours f\u00e9ri\u00e9s)",
  footer_nav_title: "NAVIGATION",
  footer_copyright: "\u00a9 2025 Divination Tenten-Ojisan. Tous droits r\u00e9serv\u00e9s.",
  footer_privacy: "Politique de confidentialit\u00e9",
  footer_law: "Loi sur les transactions commerciales sp\u00e9cifi\u00e9es",
  footer_sitemap: "Plan du site",
};

export default fr;
